// extracted by mini-css-extract-plugin
module.exports = {"SectionContainer":"SectionContainer_SectionContainer__UyOxK"};